import forgotPasswordModal from './forgotPasswordModal.html';
import forgotUsernameModal from './forgotUsernameModal.html';

/* @ngInject */
export default function ($scope, AuthService, $state, $stateParams, $window, toastr, LayoutService, $uibModal) {
	if (AuthService.isLoggedIn()) {
		if ($stateParams.r) {
			$window.location.href = $stateParams.r;
		} else {
			$state.go('splash.home');
		}
	} else {
		LayoutService.reset();
		LayoutService.setTitle('Login');

		$scope.username = '';
		$scope.password = '';

		$scope.login = () => {
			if ($scope.validate()) {
				let credentials = {
					username: $scope.username,
					password: $scope.password,
				};

				AuthService
					.authenticate(credentials)
					.then(
						(user) => {
							AuthService.fireOnLoginCallbacks();

							toastr.clear();
							toastr.success('Welcome to All About Caring.');

							if ($stateParams.r) {
								$window.location.href = $stateParams.r;
							} else {
								$state.go('splash.home');
							}
						},
						() => {
							toastr.clear();
							toastr.error('Your credentials were incorrect.', 'Error');
						},
						() => {
							toastr.clear();
							toastr.info('Loading your account information now...', 'You were logged in successfully.');
						},
					);
			}

			return false;
		};

		$scope.validate = () => {
			if ($scope.username == '') {
				toastr.clear();
				toastr.warning('You must provide your User ID.', 'Error');

				return false;
			}

			if ($scope.password == '') {
				toastr.clear();
				toastr.warning('You must provide your Password.', 'Error');

				return false;
			}

			return true;
		};

		$scope.openForgotUsernameModal = () => {
			const modalInstance = $uibModal.open({
					animation: true,
					template:  forgotUsernameModal,
				},
			);
		};

		$scope.openForgotPasswordModal = () => {
			const modalInstance = $uibModal.open({
					animation:                  true,
					template:                   forgotPasswordModal,
					controller: /* @ngInject */ ($scope, $uibModalInstance, toastr, AuthService) => {
						$scope.cancel = () => {
							$uibModalInstance.close();
						};

						$scope.resetPassword = () => {
							if ($scope.validate()) {
								AuthService.resetPassword({
									           username: $scope.username,
								           })
								           .then(() => {
									           toastr.clear();
									           toastr.success('Your password has been reset, please check your email inbox.', 'Password Reset');

									           $uibModalInstance.close();
								           })
								           .catch(() => {
									           toastr.clear();
									           toastr.error('There was an error while resetting your password, please try again or contact All About Caring.', 'Error');
								           });
							}
						};

						$scope.validate = () => {
							if ($scope.username == '') {
								toastr.clear();
								toastr.warning('You must provide your User ID.', 'Error');

								return false;
							}

							return true;
						};
					},
				},
			);
		};
	}
}
;


// WEBPACK FOOTER //
// ./src/js/endpoints/auth/login/controller.js